<div class="current-location-infowindow">
	
	<img class="current-location-infowindow-image" ng-src="assets/map/yrloc.png" alt="Loca&#539;ia ta curent&#259;">
	
	<h1 class="current-location-infowindow-name">Loca&#539;ia ta curent&#259; *</h1>

	<p class="current-location-infowindow-details">* ob&#539;inut&#259; prin <span class="current-location-infowindow-light-text">c&#259;utare</span> sau <span class="current-location-infowindow-light-text">localizare</span></p>
	
	<div class="current-location-infowindow-clear"></div>
</div>